/* eslint-disable @typescript-eslint/no-var-requires */
import { $t, $thesaurus } from '../base-facade';
import { createThesaurusService } from '../thesaurus-service';

import { Metadata$Field, Metadata$Template } from './types/Metadata';

const metadataFieldsService = createThesaurusService<Metadata$Field>('/metadata-field');
const metadataTemplatesService = createThesaurusService<Metadata$Template>('/metadata-template');

export { $t, $thesaurus, metadataFieldsService, metadataTemplatesService };

if (process.env.VUE_APP_MOCK_API === 'yes') {
  (function _bootstrap() {
    const adapter = require('@/mocks/index').default;
    require('./mocks/metadata-fields').default(adapter);
    require('./mocks/metadata-templates').default(adapter);
    require('./mocks/metadata').default(adapter);
  })();
}
